module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Baptiste_1.5858e1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Baptiste_1.jpg
// module id = dqyL
// module chunks = 0